// i18n area 'cluster' — locale et-EE (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.et-EE.meta.json.
import type { enUS } from './cluster'

export const etEE: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Garantiipääsud',
      subtitle: 'Sõlme hooldusuks: kirjutuskaitstud pääs ajutise parooliga ja hädaabikonto seifi parooliga',
      readOnlyTitle: 'Kirjutuskaitstud pääs (trantor)',
      stateNone: 'suletud',
      stateGranted: 'avatud',
      stateGrantedPending: 'antud — rakendatakse sõlmel',
      grantedBy: 'Andis',
      grantedAt: 'Antud',
      expiresAt: 'Aegub',
      reason: 'Põhjus',
      endedAt: 'Suletud',
      endedReason: {
        revoked: 'tühistatud',
        expired: 'aegunud (TTL)',
        reboot: 'sõlme taaskäivitus',
        failed: 'rakendamata (ülesanne ebaõnnestus)'
      },
      grant: 'Anna kirjutuskaitstud pääs…',
      grantTitle: 'Anna kirjutuskaitstud pääs',
      grantSubmit: 'Anna',
      grantError: 'Andmine lükati tagasi',
      grantConfirm: 'TVirt genereerib süsteemikasutajale «trantor» ajutise parooli (ainult lugemine: journal ja diagnostika, ilma sudota) ja seab selle sõlmel ülesandega. Parooli näidatakse AINULT üks kord, kinnitamisel; see lõpeb tähtajal, tühistamisel või sõlme järgmisel taaskäivitusel.',
      reasonLabel: 'Põhjus',
      reasonHint: 'Miks sa ukse avad: see jääb andmisse, auditisse ja päevikusse',
      ttlLabel: 'Kestus',
      ttlHours: '{n} h',
      revoke: 'Tühista kirjutuskaitstud pääs…',
      revokeTitle: 'Tühista kirjutuskaitstud pääs',
      revokeSubmit: 'Tühista',
      revokeError: 'Tühistamine lükati tagasi',
      revokeConfirm: 'Andmine lõpeb kohe ja ülesanne lukustab kasutaja «trantor» sõlmel uuesti: ajutine parool lakkab kehtimast.',
      passwordTitle: 'Kirjutuskaitstud parool',
      passwordOnce: 'Seda parooli näidatakse AINULT üks kord: kopeeri see kohe. Seda ei salvestata kuhugi ja seda ei saa uuesti lugeda — kui kaotad selle, anna uuesti.',
      passwordUser: 'Kasutaja',
      passwordLabel: 'Parool',
      passwordHint: 'Kehtib kuni {until} või sõlme järgmise taaskäivituseni; kasutatav, kui andmisülesanne on lõpetatud. Ligipääs: ssh trantor@<sõlme aadress>.',
      emergencyTitle: 'Viimane hädaabipääs (trantor-emergency)',
      lastLogin: '{time} kaudu {via} aadressilt {from}',
      lastLoginNone: 'ei ole täheldatud',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konsool',
        sudo: 'sudo',
        unknown: 'teadmata'
      },
      emergencyHint: 'Hädaabikonto «trantor-emergency» (täielik sudo) on alati lubatud parooliga, mis genereeriti sõlme paigaldamisel ja mida hoitakse seifis: TVirt ei tea seda, ei roteeri ega taasta. Iga sisselogimine raporteeritakse siin ja sündmuste päevikus.'
    },
    nodeFirewall: {
      tab: 'Tulemüür',
      title: 'Sõlmede tulemüür',
      subtitle: 'Selle nftables-ruleset’i hoiak, mille iga sõlm endale rakendab — sõlme ainus tulemüür (firewalld on keelatud)',
      modeLabel: 'Hoiak',
      mode: {
        disabled: 'Keelatud — sõlmedel pole ühtegi ruleset’i',
        permissive: 'Lubav — loeb ja logib, ei hülga midagi',
        enforced: 'Jõustatud — sisse pääseb ainult tuletatud register'
      },
      hint: {
        disabled: 'Nagu täna: sõlmed ei kanna ühtegi ruleset’i. Lülitu lubavale, et LUGEDA, mis hüljataks, enne kui see hüljatakse.',
        permissive: 'Iga sõlm rakendab oma tuletatud ruleset’i policy accept režiimis: see, mille jõustatud režiim hülgaks, loendatakse ja logitakse (journali prefiks «tvirt-node would-drop:»). Midagi ei blokeerita.',
        enforced: 'Iga sõlm rakendab oma tuletatud ruleset’i policy drop režiimis: ssh ja API kõikjalt, store / live migration / overlay / Ceph ainult liikmetelt, võrguteenuste listener’id teenindatavast võrgust. Iga muudatus on kinnitusega apply — sõlm, mis kinnitada ei suuda, pöördub ise tagasi.'
      },
      confirmTitle: 'Jõustada sõlmede tulemüür?',
      confirmBody: 'Iga sõlm rakendab ruleset’i kinnitusega: sondeerib tähtaja jooksul läbi uute reeglite backend’i, store’i ja ssh’d ning kinnitab — muidu pöördub ise eelmise ruleset’i juurde tagasi. Loe enne sõlmedel lubava režiimi loendureid.',
      confirmSubmit: 'Jõusta',
      confirmCancel: 'Loobu',
      lensTitle: 'Sõlme tulemüür',
      loadError: 'Sõlme tulemüüri läätse ei õnnestunud laadida',
      noReport: 'Sellelt sõlmelt pole veel ühtegi tulemüüri raportit — worker annab aru järgmisel ringil',
      firewalldActive: 'Sellel sõlmel töötab firewalld: sõlme tulemüür keeldub end selle kõrvale rakendamast (maskeeri firewalld)',
      conditionUnconfirmed: 'Ühtegi kinnitatud ruleset’i veel pole — sõlm on lahti',
      conditionRolledBack: 'Viimane apply pöördus tagasi — sama generatsiooni ei proovita uuesti enne, kui register muutub või hoiakut uuesti muudetakse',
      lastError: 'Viimane viga',
      posture: 'Hoiak',
      observedAt: 'Vaadeldud',
      desiredGeneration: 'Soovitud generatsioon',
      componentTitle: 'Sõlme komponent',
      componentSubtitle: 'tvirt-node-firewall — rakendab buutimisel kinnitatud ruleset’i, pöörab kinnitamata ruleset’i ise tagasi',
      componentAbsent: 'Komponent pole veel aru andnud',
      phase: 'Faas',
      phases: {
        none: 'Pole kunagi rakendatud',
        applied: 'Rakendatud — ootab kinnitust',
        confirmed: 'Kinnitatud',
        rolledBack: 'Tagasi pööratud'
      },
      generation: 'Generatsioon',
      appliedAt: 'Rakendatud',
      confirmedAt: 'Kinnitatud',
      deadline: 'Rollback’i tähtaeg',
      lastRollback: 'Viimane rollback',
      registryTitle: 'Tuletatud register',
      registrySubtitle: 'Pordid, mille see sõlm avab, klassi ja päritolu kaupa — tuletatud klastrist, mitte kunagi käsitsi muudetud',
      registryEmpty: 'Midagi pole tuletatud — hoiak on keelatud ilma kinnitatud ruleset’ita, või pole veel raportit',
      colClass: 'Klass',
      colPort: 'Port',
      colSource: 'Allikas',
      colOrigin: 'Päritolu',
      classes: {
        public: 'Avalik',
        internode: 'Sõlmedevaheline',
        tenant: 'Tenant'
      },
      sourceMembers: 'ainult liikmed',
      sourceAnywhere: 'kõikjalt',
      sourceBridge: '{iface} peal'
    },
    derivationDerived: 'tuletatud',
    derivationDiverged: 'kõrvale kaldunud',
    derivationDerivedTip: 'Võrgudokument on TULETATUD fabricust {fabric} ja kattub endiselt renderiga praegustel sisenditel — klõpsa tuletusplaani jaoks.',
    derivationDivergedTip: 'Tuletus fabricust {fabric} muutus pärast viimast apply\'d (fabric, kaabeldus, rollid või viited) — klõpsa ootel diffi jaoks.',
    derivationRetiring: {
      one: '{n} aadress tühjenemas',
      other: '{n} aadressi tühjenemas'
    },
    standaloneHint: 'Sellel sõlmel ei ole klastrit: seda ei ole veel paigaldatud. Klastreid luuakse VÕI nendega liitutakse paigaldamise ajal — liikme Serverite tabelis genereeritud token antakse ette installerile (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Sinu õigused katavad ühe scope’i, mitte kogu klastrit: pargi inventar — sõlmed, seaded ja seadmed — on nähtav ainult klastri administraatoritele.',
    phaseReady: 'Valmis',
    phaseForming: 'Moodustumisel',
    storeMembers: "Store'i liikmed",
    watermark: 'Konvergentsi lävi',
    configGeneration: 'Konfiguratsiooni generatsioon',
    converged: 'kooskõlas',
    behind: 'maas — {m} / {n}',
    revision: 'Revisjon',
    rolesTitle: 'Võrgurollid',
    rolesSubtitle: 'Aadressid liikme kohta iga liiklusklassi jaoks — ühenduvus elab hosti võrgus',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'pärib managementi',
    settingsTitle: 'Seaded',
    settingsSubtitle: 'Klastri tasandi turvapoliitika — iga sõlm hindab seda oma kohalikust replikast',
    taskRetentionTitle: 'Taskide säilitus',
    taskRetentionSubtitle: 'Ühtne GC kõigi taskide jaoks — vanuse või ülempiiri ületanud lõpetatud taskid korjatakse kokku, pooleliolevaid mitte kunagi',
    taskRetentionMaxAge: 'Maksimaalne vanus (päevades)',
    taskRetentionMaxCount: 'Taskide maksimaalne arv',
    eventRetentionTitle: 'Sündmuste säilitus',
    eventRetentionSubtitle: 'Päeviku GC — ülesannetest sõltumatu poliitika: ülesanne on järjekord, sündmus on mälu',
    eventRetentionMaxAge: 'Suurim vanus (päeva)',
    eventRetentionMaxCount: 'Suurim salvestatud sündmuste arv',
    spaceThresholdsTitle: 'Ruumi läved',
    spaceThresholdsSubtitle: 'Millal täituv salvesti jõuab päevikusse (ja teavitustesse)',
    spaceLowPct: 'Hoiatus alates (% kasutatud)',
    spaceCriticalPct: 'Kriitiline alates (% kasutatud)',
    spaceOrderError: 'Kriitiline ei saa olla hoiatusest madalamal',
    spaceThresholdsHint: 'Seadistatakse ainult sisenemised: väljumise tuletab mootor, 5 punkti iga läve alla, et joonel seisev salvesti ei muutuks kunagi metronoomiks',
    failoverReserveTitle: 'Failover-reserv',
    failoverReserveSubtitle: 'Admission control N+1 — vabana hoitav RAM, et klaster saaks pärast sõlmede kaotust oma töökoormuse taaskäivitada',
    failoverReserveTolerate: 'Sõlmede arv, mille kaotust taluda',
    failoverReserveOff: '0 — reserv on välja lülitatud: ühtegi käivitust ei lükata kunagi tagasi failoveri mahu pärast',
    failoverReserveOn: 'Käivitus, mis reservi riivaks, lükatakse tagasi veaga 412, mis numbrid lahti seletab',
    networkShapingTitle: 'Ribalaiuse õiglus',
    networkShapingSubtitle: 'Uplingi shaping-puu kolm tüpoloogiakaalu — need mõjuvad ainult konkurentsi korral',
    networkShapingRest: 'Ülejäänu kaal (juhtkiht, storage, replikad)',
    networkShapingOverlay: 'Overlay-võrkude kaal',
    networkShapingLiveMigration: 'Live migration\'i kaal',
    networkShapingHint: 'Tagatud osa = kaal / kolme summa (vaikimisi 300 / 100 / 200, igaüks 1 kuni 10000); vabal lingil võib iga klass võtta kogu ribalaiuse',
    debugModeTitle: 'Debug-režiim',
    debugModeSubtitle:
      'Detailsed vead üldistes GUI teadetes — et näha tegelikku põhjust, kui „ebaõnnestunud“ toiming tegelikult õnnestus',
    debugModeLabel: 'Debug-režiim on sees',
    debugModeOn: 'Üldised veateated lisavad aluseks oleva põhjuse — sisemised üksikasjad nähtavad igale operaatorile',
    debugModeOffHint: 'Väljas — üldised veateated jäävad üldisteks, ilma sisemiste üksikasjadeta',
    nodeDetailsAction: 'Sõlme üksikasjad',
    node: {
      docTitle: 'Sõlm',
      notFound: 'Sõlme ei leitud',
      tabOverview: 'Ülevaade',
      tabStats: 'Statistika',
      tabNetwork: 'Võrk',
      tabSettings: 'Kohalikud seaded',
      identityTitle: 'Identiteet',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL-port',
      revision: 'Konfiguratsiooni revisjon',
      versionsTitle: 'Vaadeldud versioonid',
      heartbeatSubtitle: 'Viimane olek, mille sõlm enda kohta raporteeris',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU mudel',
      memoryTitle: 'Mälu',
      hugePagesTitle: 'Hiiglaslikud leheküljed',
      hugePagesPool: '{size}: {free} vaba {total}-st',
      hugePagesNone: 'Kogumit pole',
      hugePagesNoneHint: 'Sõlmel ei ole hiiglaslikke lehekülgi reserveeritud: neid küsivad VM-id ei saa siin käivituda. Kogum deklareeritakse sõlmes kerneli parameetritega hugepagesz ja hugepages või kirjutades nr_hugepages.',
      usageTitle: 'Praegune kasutus',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'pole vaadeldud — värskeid proove ei ole',
      statsNoData: 'Selles vahemikus andmeid ei ole — sõlme aegridu mõõdab sõlm ise ja neid serveeritakse kohapeal.',
      observedTitle: 'Vaadeldud olek',
      observedSubtitle: 'Sõlme kohalikud teenused ja varad nii, nagu worker neid näeb'
    },
    editRolesTitle: 'Muuda võrgurolle',
    memberNode: 'Sõlm',
    memberIp: 'IP-aadress',
    addMember: 'Lisa liige',
    lmInherit: 'Kasuta managementi aadresse',
    roleIpHint: 'Liikmete lisamine ja eemaldamine on vaba; olemasoleva liikme IP muutmine kohapeal lükatakse tagasi — IP migratsiooni voog jõuab kohale mõne järgmise vooruga.',
    roleError: 'Rollide uuendamine ebaõnnestus',
    nodesTitle: 'Sõlmed',
    addNodeTitle: 'Lisa sõlm klastrisse',
    addNode: 'Lisa sõlm',
    addNodeError: 'Sõlme eelregistreerimine ebaõnnestus',
    nodeName: 'Sõlme nimi',
    nodeNameHint: 'peab kattuma paigaldamisel valitud nimega',
    nodeIp: 'Managementi IP',
    colName: 'Nimi',
    colPhase: 'Faas',
    colServices: 'Teenused',
    colWatermark: 'Watermark',
    colLastSeen: 'Viimane kontakt',
    colUps: 'UPS',
    upsCordonChip: 'UPS-i kordon',
    upsCordonTip: 'Sõlm mõistis end oma UPS-i faktide põhjal hukka ({time}): ta eemaldab kordoni ise, kui võrk on stabiilne ja aku laetud',
    upsUnreachable: 'UPS pole kättesaadav',
    upsOnBattery: 'Akul',
    upsOnLine: 'Võrgutoitel',
    upsLowBattery: 'aku tühi',
    upsNoEstimateChip: 'tööaeg hindamata',
    upsNoEstimateTip: 'UPS ei avalda tööaja hinnangut: sõlm mõistetakse hukka ainult UPS-i LB-lipu (aku tühi) põhjal — seadistage battery.runtime.low / LB UPS-il endal',
    upsLaneTip: 'UPS-i seiskamisrada alates {since}: hukka mõistetud: {by}',
    upsUnit: 'üksus',
    upsStatus: 'NUT-i olek',
    upsLoad: 'koormus',
    upsOnBatterySince: 'akul alates',
    upsOnLineSince: 'võrgutoitel alates',
    upsError: 'viga',
    upsObservedAt: 'vaadeldud',
    upsNone: 'ükski UPS-i üksus ei teeninda seda sõlme',
    upsBy: {
      runtime: 'tööaeg alla läve',
      lowBattery: 'UPS-i LB-lipp',
    },
    upsLane: {
      evacuate: 'evakueerimine',
      local: 'seiskamine kohapeal',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'külaliste peatamine',
      stoppingServices: 'teenuste peatamine',
      poweredOff: 'välja lülitatud',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS-i üksused ja läved: sõlm mõistetakse hukka tööajal ≤ lävi või LB-lipu korral (alati arvestatud), jätkamine hüstereesiga',
    upsRuntimeThreshold: 'Tööaja lävi (s)',
    upsRuntimeThresholdHint: 'Akul, hinnangulise tööajaga ≤ lävi seiskub sõlm järjekorras (vaikimisi 300)',
    upsResumeStable: 'Võrk stabiilne (s)',
    upsResumeStableHint: 'Jätkamine ainult vähemalt nii mitu sekundit katkematu võrguga (vaikimisi 60)',
    upsResumeCharge: 'Minimaalne laetus jätkamisel (%)',
    upsResumeChargeHint: 'Ja aku laetud vähemalt selle protsendini (vaikimisi 25)',
    upsPolicyNote: 'UPS-i LB-lipp (aku tühi) mõistab alati hukka ja seda ei saa välja lülitada; akul veedetud ajale läve pole. Iga üksus võib kolm arvu üle kirjutada.',
    upsUnitNew: 'uus üksus',
    upsUnitSelectors: '{n} sildivalija(t) (ainult CLI)',
    upsUnitName: 'Üksuse nimi',
    upsUnitMode: 'Režiim',
    upsModeExternal: 'väline (võõras upsd)',
    upsModeManaged: 'hallatav (sõlmega ühendatud UPS)',
    upsUnitUpsname: 'NUT-i nimi (upsname)',
    upsUnitHost: 'upsd host',
    upsUnitAttachedNode: 'Ühendatud sõlm',
    upsUnitDriver: 'NUT-i draiver',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Draiveri seade',
    upsUnitDeviceHint: 'ups.conf-i rida port=: tühi = auto',
    upsUnitPort: 'upsd port',
    upsUnitServedNodes: 'Teenindatavad sõlmed',
    upsUnitServedNodesHint: 'sõlmede nimed komadega eraldatult (sildivalijad käivad CLI kaudu)',
    upsUnitOverrideHint: 'tühi = klastri vaikeväärtus',
    upsUnitAdd: 'Lisa üksus',
    unreachableSince: 'Kättesaamatu — viimane heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Overlay dataplane ei ole praegust overlay-konfiguratsiooni veel teostanud',
    overlaysError: 'Viimane overlay ühtlustamise läbimine ebaõnnestus: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Ootab liitumist',
      'joining': 'Liitumas',
      'member': 'Liige'
    },
    tokenTitle: 'Liitumistoken',
    tokenOnce: 'Kuvatakse ainult praegu — kopeeri see kohe, hiljem ei ole see enam loetav',
    copy: 'Kopeeri',
    copied: 'Kopeeritud',
    close: 'Sulge',
    revokeTitle: 'Tühista eelregistreerimine',
    revoke: 'Tühista',
    revokeError: 'Registreerimise tühistamine ebaõnnestus',
    promote: "Ülenda store'i liikmeks",
    demote: "Eemalda store'i liikme roll",
    troubleshoot: 'Tõrkeotsing',
    promoteTitle: "Ülenda store'i liikmeks",
    demoteTitle: "Eemalda store'i liikme roll",
    promoteHint: "Sõlm astub YugabyteDB masterite kvoorumisse. Tõeline HA nõuab kolme store'i liiget.",
    demoteHint: 'Sõlm väljub masterite kvoorumist ja peatab oma store-teenused.',
    storeError: "Store'i liikmesuse muutmine lükati tagasi",
    attest: 'Atesteeri seiskunuks…',
    attestTitle: 'Atesteeri sõlm seiskunuks',
    attestSubmit: 'Atesteeri seiskunuks',
    attestConfirm: "Kuulutad selle sõlme seiskunuks omal vastutusel: tegelikult elus sõlme atesteerimine riskib VM-ide topeltkäivitusega. Tema taskid loetakse nurjunuks ja tema VM-ide authority'd muutuvad ülekantavaks.",
    attestError: 'Atesteerimine lükati tagasi',
    attestedChip: 'atesteeritud seiskunuks',
    maintenanceChip: 'hooldus',
    guestToolsChip: 'TVirt Guest Tools (sõlme kohalik ISO-vara)',
    maintenanceEnter: 'Lülita hooldus sisse',
    maintenanceExit: 'Lülita hooldus välja',
    maintenanceEnterTitle: 'Lülita hooldus sisse',
    maintenanceExitTitle: 'Lülita hooldus välja',
    maintenanceEnterSubmit: 'Lülita hooldus sisse',
    maintenanceExitSubmit: 'Lülita hooldus välja',
    maintenanceEnterConfirm: 'Sõlm eraldatakse ja tühjendatakse: võrguteenused ja App-eksemplarid, mille authority tal on, viiakse üle (eksemplarid külmalt: siin peatatud ja koristatud, sihtsõlmes uuesti loodud — seisak), töötavad VM-id migreeritakse võimalusel elavalt ja muidu peatatakse sujuvalt, käimasolevad ülesanded lõpetatakse, uus töö ootab ja peatatud VM-id kaotavad oma authority — Proximity paigutab need järgmisel käivitusel uuesti. Hoolduse lõppedes ei tule miski ise tagasi.',
    maintenanceExitConfirm: 'Sõlm asub taas tööle ja Proximity hakkab teda paigutamisel jälle arvesse võtma. VM-id naasevad alles siis, kui nad käivitatakse.',
    maintenanceError: 'Hoolduse taotlus lükati tagasi',
    maintenancePlanTitle: 'Evakueerimisplaan',
    maintenancePlanLoading: 'Evakueerimisplaani arvutamine…',
    maintenancePlanError: 'Evakueerimisplaani laadimine ebaõnnestus — tühjendus migreerib ikkagi seal, kus saab, ja seiskab ülejäänu.',
    maintenancePlanEmpty: 'Sellel sõlmel pole midagi evakueerida — ühtegi aktiivset võrguteenust, ühtegi töötama soovitud App-eksemplari, ühtegi töötavat VM-i.',
    maintenancePlanSummary: '{migrate} objekti migreeritakse (VM-id, võrguteenused, App-eksemplarid), {stop} peatatakse või jäävad sinna, kus on.',
    maintenancePlanReserve_ok: 'Failover-reserv pärast tühjendamist: terve — käivitada saab veel {headroom} GiB, taludes {n} sõlme kaotust.',
    maintenancePlanReserve_eroded: 'Failover-reserv pärast tühjendamist: peaaegu ära kulutatud — alles on ainult {headroom} GiB neist {reserve} GiB-st, mida hoitakse vabana {n} sõlmerikke jaoks.',
    maintenancePlanReserve_exhausted: 'Failover-reserv pärast tühjendamist: OTSAS — puudu jääb {headroom} GiB neist {reserve} GiB-st, mida on vaja {n} sõlmerikke talumiseks. Kuni see sõlm on väljas, lükatakse uued VM-ide käivitused tagasi.',
    maintenancePlanReserve_unknown: 'Failover-reserv pärast tühjendamist: ei ole arvutatav — ükski järelejäänud sõlm ei ole oma mälu deklareerinud.',
    maintenancePlanReserveHugePages: 'Hiiglaslikud {size} leheküljed pärast tühjendamist — vabad: {free} / {capacity}, reservina nõutud: {reserve}.',
    maintenancePlanActionMigrate: 'migreerub',
    maintenancePlanActionMigrateWarning: 'migreerub (pehme reegel rikutud)',
    maintenancePlanActionStop: 'seiskub',
    maintenancePlanActionBlocked: 'blokeeritud',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'võrguteenus',
    maintenancePlanKindApp: 'App-eksemplar',
    maintenancePlanColdMove: 'Külm ümberpaigutus: pod peatatakse ja koristatakse siin ning sihtsõlme worker loob selle uuesti — seisak kuni sihtsõlme workeri järgmise passini.',
    caFingerprint: 'Klastri CA sõrmejälg',
    staleChip: 'pole värske',
    troubleshootTitle: "Store'i tõrkeotsing",
    restartStore: 'Taaskäivita store-teenused',
    restartHint: 'Kui store tõrgub, taaskäivita tema teenused. Edasijõudnutele — kasuta ettevaatlikult.',
    restartQueued: 'Taaskäivitustask on järjekorras',
    restartError: 'Teenuste taaskäivitamine ebaõnnestus',
    svcActive: 'aktiivne',
    svcWanted: 'soovitud, pole aktiivne',
    svcStopped: 'seisatud',
    noServices: 'Ühtegi teenust ei ole raporteeritud'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Kogu klastri GPU-inventuur mudelite kaupa rühmitatuna — sõlmede kaupa vaadeldud kaardid koos märgitud registreeringute ja nende siltidega',
    usbTitle: 'USB-ressursid',
    usbSubtitle: 'Kogu klastri USB-inventuur mudelite kaupa rühmitatuna — sõlmede kaupa vaadeldud seadmed koos mõlema mudeli registreeringutega (seadmepõhine, pordipõhine) ja nende siltidega',
    markedChip: '{n} TVirtile kasutatavat',
    orphanChipGpu: '{n} orbu',
    orphanChipUsb: '{n} orbu',
    colNode: 'Sõlm',
    colRegistration: 'Registreering',
      noRegsHint: 'Ühtegi registreeringut ei ole — seade märgitakse "TVirtile kasutatavaks" sõlme dialoogis (Sõlmed › sõlm › Seaded).',
      colDevice: 'Seade',
      colObserved: 'Vaadeldud',
      colRegs: 'Registreeringud',
      regsNone: 'puuduvad',
      colPci: 'PCIe-aadress',
      colIdentity: 'Identiteet / port',
      colClasses: 'Klassid (sildid)',
      colActions: 'Toimingud',
      manageOnNode: 'Halda sõlmes {node} (märgistus elab sõlme dialoogis)',
      introTitle: 'Klastri inventuur TVirt© poolt kasutatavatest USB- ja PCIe-seadmetest.',
      introStep1: '1. Sõlmed avastavad oma GPU-d ja USB-seadmed ise (loendus heartbeatis).',
      introStep2: '2. Seade märgitakse "TVirtile kasutatavaks" SÕLME dialoogis (Sõlmed › sõlm › Seaded) — märgistus seob ta vfioga ja registreerib siia.',
      introStep3: '3. Siin annad registreeringutele nende KLASSID siltide kaudu (nt gpu_class=compute): VM-ide nõuded küsivad klassi ja scheduler valib sõlme, kus on vaba ühilduv seade.',
    colMode: 'Režiim',
    colState: 'Olek',
    colNotes: 'Märkmed',
    colTags: 'Sildid',
    modeDevice: 'seadmepõhine',
    modePort: 'pordipõhine',
    usable: 'kasutatav',
    orphanGpu: 'orb',
    orphanUsb: 'orb',
    hubChip: 'hub',
    orphanPortsTitle: 'Pordipõhised registreeringud ilma ühendatud seadmeta — ühenda seade uuesti või eemalda nende märgistus sõlmes',
    gpusEmpty: 'Üheski sõlmes ei ole veel ühtegi GPU-d vaadeldud',
    usbEmpty: 'Üheski sõlmes ei ole veel ühtegi USB-seadet vaadeldud'
  },

  // Seadete vormide jagatud sõnavara (refaktoreering 2026-07-24): security
  // väljad toidavad Klastri lehe kaarti, sõlme väljad node-settings lehte —
  // leht /system/settings, mille jaoks nad sündisid, on surnud.
  settings: {
    passwordMinLength: 'Parooli minimaalne pikkus',
    sessionIdle: 'Seansi jõudeoleku ajapiirang (minutites)',
    lockoutThreshold: 'Lukustus pärast nurjunud katseid',
    lockoutDuration: 'Lukustuse kestus (minutites)',
    keyboardLayout: 'Klaviatuuripaigutus',
    keyboardLayoutHint: 'nt it, en-us — tühi tähendab QEMU vaikeväärtust',
    syslogEndpoint: 'Syslogi endpoint',
    syslogEndpointHint: 'host:port — tühi keelab edastuse',
    syslogTls: 'TLS',
    maxQueued: 'Maksimaalne taskide arv järjekorras',
    concurrency: 'Workeri samaaegsus',
    concurrencyHint: 'Worker rakendab lennult',
    notesTitle: 'Märkmed',
    save: 'Salvesta',
    saved: 'Seaded salvestatud',
    saveError: 'Seadete salvestamine ebaõnnestus'
  },
  localSettings: {
    derivedChip: 'tuletatud',
    derivedTip: 'See device KUULUB fabric-tuletusele (H2): editor keeldub seda puudutamast — muuda fabricut (või kaabeldust) ja rakenda uuesti, või võta see allpool tagasi.',
    takeOwnership: 'Võta omandusse',
    takeOwnershipTitle: 'Võta omandusse (take-ownership)',
    takeOwnershipConfirm: '{name} lahkub fabric-plokist ja saab taas MANUAALSEKS device\'iks, mida see editor valitseb. Node muutub kõrvale kaldunuks ja järgmine tuletus-apply keeldub sellel (manualConflict), kuni sa selle ümber nimetad või eemaldad — või parandad fabricu.',
    nodeSettingsTitle: 'Sõlme seaded',
    nodeSettingsSubtitle: 'See, mida see sõlm rakendab — taskide järjekord, konsool, logide edastus — pluss tema sildid ja märkmed',
    baseTitle: 'Hosti reservid (TVirt Proximity)',
    baseSubtitle: 'Hosti operatsioonisüsteemile reserveeritud CPU ja RAM — empiirilise mahu sisendid, millega Proximity VM-e paigutab',
    baseMemory: 'Baas-RAM (MiB)',
    baseMemoryHint: 'Vaadeldud kogumaht: {total} MiB. VM-idele kasutatav = kogumaht − baas − siia paigutatud töötavate VM-ide RAM.',
    baseMemoryHintNoTotal: 'VM-idele kasutatav = vaadeldud kogumaht − baas − siia paigutatud töötavate VM-ide RAM.',
    baseCpu: 'Baas-CPU tuumad',
    baseCpuHint: 'Vaadeldud loogilised CPU-d: {total}. Kasutatakse ainult järjestamise kaaluna — vCPU-de ülekohustus on tavaline.',
    baseCpuHintNoTotal: 'Kasutatakse ainult järjestamise kaaluna — vCPU-de ülekohustus on tavaline.',
    baseHint: "RAM on jäik vastuvõtuvärav: VM, mis kasutatavasse RAM-i ei mahu, lükatakse tagasi kõneka veateatega. Tõsta baasi neis hostides, mis majutavad store'i liikmeid või Ceph-i deemoneid.",
    placementTitle: 'Füüsiline paigutus',
    placementSubtitle: 'Kus see server füüsiliselt asub — deklareeritud üks kord, mille iganes tarbeks seda vaja läheb',
    placementHint: 'Paigutus juhib iga sellise Ceph-klastri CRUSH-hierarhiat, millel on selles serveris OSD: muudatuse salvestamine joondab nende kaardid taskiga ümber (host → rack → … → root). Osalised deklaratsioonid on lubatud — tühjad tasemed kukuvad kokku. Nimed on jagatud üle kogu kaardi: kaks serverit samas rackis deklareerivad sama racki nime.',
    placementNameInvalid: 'DNS-turvaline nimi (väiketähed, numbrid, sidekriipsud)',
    placementEmpty: 'Tühi = deklareerimata',
    placementLevel: {
      chassis: 'Šassii',
      rack: 'Rack',
      row: 'Rida',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Ruum',
      datacenter: 'Andmekeskus',
      zone: 'Tsoon',
      region: 'Regioon'
    },
    cablingTitle: 'Kaabeldus',
    cablingSubtitle: 'Millisesse switchi porti iga liides on ühendatud — deklaratsioon elab sõlmes (Annex O.9)',
    cablingHint: 'Üks kaabel NIC-i kohta, üks kaabel pordi kohta üle kogu pargi (API lükkab tagasi, nimetades omaniku). LAGG-i liikmesporti kaabeldamine on lubatud — see ongi bondi juhtum: tulevane tuletus renderdab selle LACP-na.',
    cablingInterface: 'Liides',
    cablingNotCabled: '— pole ühendatud —',
    cablingNoInterfaces: 'Ühtegi võrguliidest ei ole vaadeldud',
    disksTitle: 'Kettad',
    disksSubtitle: 'Vaadeldud plokkseadmed — üks skannimine ühtlustamise läbimise kohta; märgi siin kettad, mida saab kasutada Ceph-i OSD-dena (N.15: sobivus on selgesõnaline)',
    colDataDisk: 'Andmeketas',
    dataDisksHint: 'Seadme märkimine kuulutab ta OSD-na kasutatavaks; seerianumber on tema identiteedi pin — kopeeritud riistvarast, kui ketas selle raporteerib, muidu vermitud (tvirt-…). Ceph-i registreerimise dialoog pakub ainult deklareeritud kettaid.',
    diskDeclaredSerial: 'deklareeritud',
    diskNotObserved: 'deklareeritud, kuid pole vaadeldud — haagi seade uuesti või võta linnuke ära',
    noDisks: 'Ühtegi plokkseadet ei ole veel vaadeldud',
    colSerial: 'Seerianumber',
    colModel: 'Mudel',
    colSize: 'Maht (GiB)',
    colDiskType: 'Tüüp',
    colInUse: 'Kasutusel',
    colObservedAt: 'Vaadeldud',
    diskInUse: 'kasutusel',
    diskFree: 'vaba',
    diskMounted: 'haagitud',
    diskPartitions: 'partitsioonid',
    passthroughTitle: 'Passthrough-seadmed',
    passthroughSubtitle: 'Vaadeldud GPU-d ja USB-seadmed — märgi siin, mida TVirt tohib VM-idele edasi anda; märgistus registreerib seadme identiteedi (voorud U1+G1)',
    passthroughHint: 'Märgistus registreerib seadme (stabiilne id — siltide ja klassinõuete siht). Märgitud GPU puhul seotakse KOGU IOMMU-grupp korraga vfio-pci külge — see lahkub hostist otsekohe; märgistuse eemaldamine haagib natiivse draiveri tagasi. USB jaoks on olemas mõlemad ratifitseeritud mudelid: seadmepõhine (tootja+toode, kuhu iganes ta on ühendatud) ja füüsilise pordi põhine (VM-i jõuab kõik, mis sinna torgatakse). USB ei seo end märgistuse hetkel — ühendamine toimub VM-i töö ajal.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'TVirtile kasutatav',
    colGpu: 'GPU',
    colPciAddress: 'PCI-aadress',
    colDriver: 'Draiver',
    colVerdict: 'Otsus',
    gpuEligible: 'Sobiv',
    gpuIneligible: 'Ei sobi',
    gpuReason: {
      'no-iommu': 'IOMMU ei ole hostis aktiivne',
      'group-spans-slots': 'IOMMU-grupp ei ole isoleeritud: see ulatub teistesse pesadesse',
      'multiple-display': 'IOMMU-grupp ei ole isoleeritud: rohkem kui üks videofunktsioon',
      'foreign-function': 'IOMMU-grupp ei ole isoleeritud: see sisaldab võõrast funktsiooni'
    },
    vfioNotReady: 'IOMMU ei ole selles hostis aktiivne: ükski GPU ei ole sobiv enne, kui hosti platvorm selle lubab (OEM ISO) — TVirt ei näpi kunagi töö ajal kerneli argumente.',
    vfioMissingKernelArg: 'IOMMU ei ole selles hostis aktiivne: püsivara raporteerib VT-d/AMD-Vi (ACPI tabel DMAR/IVRS on olemas), kuid kerneli argument puudub — lisa kerneli käsureale intel_iommu=on (Intel) või eemalda sealt amd_iommu=off (AMD) ja tee taaskäivitus. TVirt ei näpi kunagi töö ajal kerneli argumente.',
    vfioFirmwareDisabled: 'IOMMU ei ole selles hostis aktiivne: VT-d/AMD-Vi on püsivaras keelatud (ACPI tabelit DMAR/IVRS ei ole) või CPU ei toeta seda — luba see püsivara seadistuses, ükski kerneli argument ei suuda seda sisse lülitada. TVirt ei näpi kunagi hosti töö ajal.',
    gpuBindError: 'vfio-pci sidumine ebaõnnestus aadressil {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: "Tulemüür haldamata bridge'idel",
    firewallBridgesSubtitle: "Sellel sõlmel käsitsi ehitatud bridge'id, mille seadistus nõustub TVirti renderdatud tulemüüri chain'idega külge pandud külaliste NIC-idel",
    firewallBridgesHint: "TVirt ei puutu võõrast bridge'i kunagi — chain ankurdub tap/veth-ile, mis on alati TVirti oma. Nimekiri on nõusolekuvärav: default-deny ja anti-spoof võivad lõhkuda selle, mida käsitsi seadistus ootab, seega tulemüüriga NIC haldamata bridge'il, mida SIIN kirjas pole, lükatakse tagasi kõneka veaga.",
    firewallBridgesEmpty: "Ükski haldamata bridge sellel sõlmel ei nõustu TVirti renderdatud tulemüüri chain'idega.",
    firewallBridgeAdd: 'Lisa bridge',
    firewallBridgeInvalid: 'Pole Linuxi liidesenimi (1-15 märki, ilma kaldkriipsu ja tühikuta)',
    firewallBridgeDuplicate: 'Nimi on juba nimekirjas',
    colMarkDevice: 'Seadmepõhine',
    colMarkPort: 'Pordipõhine',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'orb — registreeritud, kuid enam ei tuvastata: ühenda ta uuesti või eemalda märgistus',
    noGpus: 'Ühtegi GPU-d ei ole veel vaadeldud',
    noUsb: 'Ühtegi USB-seadet ei ole veel vaadeldud',
    networkGeneration: 'Võrgu generatsioon',
    applied: 'Rakendatud',
    converged: 'kooskõlas',
    behind: 'maas — {m} / {n}',
    notConfigured: 'pole konfigureeritud',
    rollbackBody: 'Generatsiooni {gen} rakendamine ebaõnnestus: {error}',
    rolledBackChip: 'tagasi pööratud',
    nicsTitle: 'NIC-id',
    nicsSubtitle:
      'Hallatavate NIC-ide register — registreerimine ONGI haldusdeklaratsioon: registreeritud NIC-i, millel konfiguratsiooni ei ole, ei puudutata (clear-if kuulutab ta selgesõnaliselt puhtaks), registreerimata seadet ei puudutata mitte kunagi',
    addNic: 'Registreeri NIC',
    addNicTitle: 'Registreeri NIC (add-nic)',
    delNic: 'Lõpeta haldamine',
    delNicTitle: 'Lõpeta haldamine (del-nic)',
    delNicConfirm:
      '{name} haldamine lõpeb: registrikirje ja tema konfiguratsioon kustutatakse ning TVirti profiil eemaldatakse — seade jääb sellisena, nagu Linux teda hoiab.',
    nicName: 'Seadme nimi',
    nicMac: 'Püsiv MAC-aadress',
    nicMacHint: 'püsiv riistvaraline MAC — stabiilne identiteet, mille fikseerib TVirt Server Installer',
    colObserved: 'Vaadeldud',
    nicObserved: 'vaadeldud',
    nicNotObserved: 'pole vaadeldud',
    nicMacMismatch: 'MAC lahkneb — vaadeldud {mac}',
    noNics: 'Ühtegi NIC-i ei ole registreeritud — registreeri seade, et hakata teda haldama',
    noManagedDevices: 'Ühtegi hallatavat seadet ei ole — registreeri kõigepealt NIC, kõik muu ehitatakse registri peale',
    inventoryTitle: 'Vaadeldud seadmed',
    inventorySubtitle: 'Uuendatakse sõlme workeri iga ühtlustamise läbimisega — valideerimine kontrollib seadmenimesid selle inventuuri järgi',
    colDevice: 'Seade',
    colType: 'Tüüp',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Kiirus',
    colTopology: 'Topoloogia',
    colMtu: 'MTU',
    colAddresses: 'Aadressid',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP ei agregeeri',
    noInventory: 'Ühtegi seadet ei ole seni raporteeritud',
    interfacesTitle: 'Liidesed',
    interfacesSubtitle:
      'Registreeritud NIC-ide ja deklareeritud loogiliste seadmete L3-konfiguratsioon — set-if asendab terve ploki, edit-if kohendab omadusi, clear-if tühjendab selle (selgesõnaline puhastus)',
    colConfig: 'Soovitud konfiguratsioon',
    clean: 'puhas',
    setIf: 'Muuda aadressiseadeid',
    setIfTitle: 'Muuda aadressiseadeid (set-if)',
    editIf: 'Muuda omadusi',
    editIfTitle: 'Muuda omadusi (edit-if)',
    clearIf: 'Tühjenda konfiguratsioon',
    clearIfTitle: 'Tühjenda konfiguratsioon (clear-if)',
    clearIfConfirm: "Liidese konfiguratsioon tühjendatakse. Puhas liides on eeltingimus selleks, et teda saaks allutada bondi või bridge'i liikmeks või VLAN-i parent-liideseks.",
    ip4Mode: 'IPv4 režiim',
    ip6Mode: 'IPv6 režiim',
    modeUnconfigured: 'Konfigureerimata',
    modeStatic: 'Staatiline',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4 aadressid',
    ip6Addresses: 'IPv6 aadressid',
    addressesHint: 'CIDR, komadega eraldatud',
    gw4: 'IPv4 gateway',
    gw6: 'IPv6 gateway',
    dns: 'DNS-serverid',
    dnsHint: 'komadega eraldatud — tühi nullib DNS-i (set-if asendab ploki)',
    routes4: 'IPv4 staatilised marsruudid',
    routes6: 'IPv6 staatilised marsruudid',
    routeTo: 'Sihtkoht (CIDR)',
    routeVia: 'Kaudu',
    addRoute: 'Lisa marsruut',
    routesChip: 'marsruuti',
    mtu: 'MTU',
    mtuHint: 'tühi = draiveri vaikeväärtus',
    vlansTitle: 'VLAN',
    addVlan: 'Lisa VLAN',
    addVlanTitle: 'Lisa VLAN (add-vlan)',
    delVlanTitle: 'Kustuta VLAN (del-vlan)',
    vlanParent: 'Parent-liides',
    vlanId: 'VLAN-i ID',
    vlanPreview: 'Seadme nimi',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Ühtegi VLAN-i ei ole deklareeritud',
    bondsTitle: 'Bond',
    addBond: 'Lisa bond',
    addBondTitle: 'Lisa bond (add-bond)',
    editBondTitle: 'Muuda bondi',
    editBond: 'Salvesta bond',
    delBondTitle: 'Kustuta bond (del-bond)',
    bondName: 'Bondi nimi',
    members: 'Liikmed',
    membersHint: 'liikmed peavad olema puhtad liidesed (ilma L3-konfiguratsioonita)',
    bondMode: 'Režiim',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Peamine liige',
    rate: 'LACP sagedus',
    hash: 'Edastuse räsipoliitika',
    colMembers: 'Liikmed',
    colMode: 'Režiim',
    noBonds: 'Ühtegi bondi ei ole deklareeritud',
    bridgesTitle: 'Bridge',
    addBridge: 'Lisa bridge',
    addBridgeTitle: 'Lisa bridge (add-bridge)',
    editBridgeTitle: "Muuda bridge'i",
    editBridge: 'Salvesta bridge',
    delBridgeTitle: 'Kustuta bridge (del-bridge)',
    bridgeName: "Bridge'i nimi",
    stp: 'STP',
    stpOn: 'STP on sees',
    stpOff: 'STP on väljas',
    colStp: 'STP',
    noBridges: "Ühtegi bridge'i ei ole deklareeritud",
    hostnameTitle: 'Hostinimi',
    hostname: 'Hostinimi',
    setHostname: 'Määra hostinimi',
    setHostnameTitle: 'Määra hostinimi (set-hostname)',
    hostnameHint: 'Ainult OS-i identiteet — sõlme nime klastris ei puudutata',
    notSet: 'määramata',
    staticHostsTitle: 'Staatilised hostikirjed',
    addStaticHost: 'Lisa kirje',
    addStaticHostTitle: 'Lisa staatiline hostikirje',
    delStaticHostTitle: 'Kustuta staatiline hostikirje',
    hostIp: 'IP-aadress',
    hostNames: 'Nimed',
    hostNamesHint: 'eraldatud koma või tühikuga',
    colIp: 'IP',
    colNames: 'Nimed',
    noStaticHosts: 'Staatilisi hostikirjeid ei ole',
    delConfirm: '{name} eemaldamine soovitud dokumendist — sõlme worker ühtlustab NetworkManageri kontrollpunkti ja automaatse tagasipööramisega.',
    remove: 'Eemalda',
    opError: 'Võrgutoiming lükati tagasi'
  }
}
